import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { Container } from '../availability_step/meeting_details/styles';
import { Card } from '../availability_step/styles';
const blockCss = "bzk1wlb";
const Block = ({
  className,
  ...props
}) => <div {...props} className={classNames(blockCss, className)} />;
const calendarBlockCss = "c1lzuw22";
const CalendarBlock = ({
  className,
  ...props
}) => <div {...props} className={classNames(calendarBlockCss, className)} />;
const calendarTitleBlockCss = "c1g8g3an";
const calendarTitleBlockPhoneCss = "c6u3gc9";
const CalendarTitleBlock = ({
  children,
  className,
  ...props
}) => {
  const isPhone = useDeviceType('isPhone');
  return <div {...props} className={classNames(calendarTitleBlockCss, {
    [calendarTitleBlockPhoneCss]: isPhone
  }, className)}>
      {children}
    </div>;
};
const hostsBlockCss = "h18y7vwi";
const HostsBlock = ({
  className,
  ...props
}) => <div {...props} className={classNames(hostsBlockCss, className)} />;
const loadingCardCss = "l8a3lyk";
const LoadingCard = ({
  className,
  ...props
}) => <Card {...props} className={classNames(loadingCardCss, className)} />;
const MobileLoading = () => <>
    <Block className="l-wide s-tall m-auto" />
    <LoadingCard>
      <CalendarBlock>
        <CalendarTitleBlock>
          <Block className="sm-wide" />
          <Block className="s-wide" />
        </CalendarTitleBlock>
        <Block className="s-wide m-auto" />
        <Block className="xl-wide" />
      </CalendarBlock>
    </LoadingCard>
  </>;
const Loading = () => <LoadingCard>
    <Container>
      <Block className="m-wide s-tall mbl" />
      <div>
        <Block className="s-wide" />
        <Block className="l-wide m-tall mbl" />
      </div>
      <HostsBlock>
        <Block className="sm-wide" />
        <Block className="l-wide m-tall mbs" />
        <Block className="m-wide" />
        <Block className="m-wide" />
      </HostsBlock>
      <div>
        <Block className="s-wide" />
        <Block className="m-wide" />
      </div>
    </Container>
    <CalendarBlock>
      <CalendarTitleBlock>
        <Block className="m-wide s-tall" />
        <Block className="s-wide m-tall" />
      </CalendarTitleBlock>
      <Block className="xl-wide" />
    </CalendarBlock>
  </LoadingCard>;
export const SkeletonLoading = () => {
  const isMobile = useDeviceType('isPhone');
  return isMobile ? <MobileLoading /> : <Loading />;
};

require("./skeleton_loading.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./skeleton_loading.js");